import React, { useState, useEffect, useRef } from 'react';
import './InputAndSelectCompo.css';

const InputAndSelectCompoBoxSmall = ({
  label,
  options,
  defaultValue = '',
  defaultOption = '',
  onChange,
  selectchange,
  border = '',
  className = '',
  validators = [],
  type = 'text',
  error,
  numericType = "none",
  isRequired = false,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [errors, setErrors] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    setValue(defaultValue);
    setSelectedOption(defaultOption);
  }, [defaultValue, defaultOption]);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (dropdownOpen && searchRef.current) {
      setTimeout(() => searchRef.current?.focus(), 50);
    }
    if (!dropdownOpen) setSearch(''); // clear search on close
  }, [dropdownOpen]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const newErrors = [];
    if (validators?.length > 0) {
      validators.forEach((validator) => {
        const result = validator(value);
        if (result !== true) newErrors.push(result);
      });
    }
    if (!hasInteracted) return;
    if (selectedOption === "" || selectedOption === null || selectedOption === undefined) {
      newErrors.push("Please select an option");
    }
    setErrors(newErrors);
  }, [value, selectedOption]);

  const handleInputChange = (event) => {
    let newValue = event.target.value;
    if (numericType === "integer") newValue = newValue.replace(/\D/g, '');
    if (numericType === "decimal") newValue = newValue.replace(/[^0-9.]/g, '');
    setValue(newValue);
    setHasInteracted(true);
    if (onChange) onChange({ ...event, target: { ...event.target, value: newValue } });
  };

  const handleKeyDown = (e) => {
    if (numericType === "none") return;
    const allowed = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (numericType === "integer") {
      if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
    }
    if (numericType === "decimal") {
      if (!/[0-9.]/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
      if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
    }
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option.value);
    setHasInteracted(true);
    setDropdownOpen(false);
    if (selectchange) selectchange({ target: { value: option.value } });
  };

  const filteredOptions = options.filter(opt =>
    (opt.searchLabel || opt.label).toLowerCase().includes(search.toLowerCase())
  );

  const selectedLabel = options.find(o => String(o.value) === String(selectedOption))?.label || '';
  const displayErrors = error ? [error] : errors;

  return (
    <div className={`small-compo-box-container ${className} ${displayErrors.length > 0 ? 'mb-20' : ''} ${border}`}>

      {/* Custom dropdown */}
      <div className="custom-select-wrapper" ref={dropdownRef}>
        <div
          className="custom-select-trigger fts-13"
          onClick={() => setDropdownOpen(prev => !prev)}
        >
          <span className="custom-select-selected-label">
            {selectedLabel || <span>&nbsp;</span>}
          </span>
          <span className="custom-select-arrow">▾</span>
        </div>

        {dropdownOpen && (
          <div className="custom-select-dropdown">
            {/* Search bar */}
            <div className="custom-select-search-wrapper">
              <input
                ref={searchRef}
                className="custom-select-search fts-12"
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>

            {/* Options list */}
            <ul className="custom-select-list">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <li
                      key={index}
                      className={`custom-select-option fts-13 ${String(option.value) === String(selectedOption) ? 'selected' : ''}`}
                      onClick={() => handleOptionSelect(option)}
                  >
                      <span className="option-symbol">{option.label}</span>
                      {option.searchLabel && (
                          <span className="option-name fts-12">{option.searchLabel.replace(option.label, '').trim()}</span>
                      )}
                  </li>
                ))
              ) : (
                <li className="custom-select-empty fts-12">No results found</li>
              )}
            </ul>
          </div>
        )}
      </div>

      {/* Price input */}
      <input
        className={`input-box compo-box-input common-text fts-13 ${errors.length > 0 ? 'input-error' : ''}`}
        type={type}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder=' '
      />

      <label className={`lt-gray fixed-input-label ${value ? 'has-value' : ''}`}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>

      {displayErrors.length > 0 && (
        <div className="input-error-message compo-box-error fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default InputAndSelectCompoBoxSmall;



// const InputAndSelectCompoBoxSmall = ({
//   label,
//   defaultValue = '',
//   defaultOption = '',
//   options,
//   onChange,
//   className='',
//   name,
//   type = 'text',
//   validators = [],
//   isRequired = false,
//   error,
// }) => {
//   const [inputValue, setInputValue] = useState(defaultValue);
//   const [selectedCurrency, setSelectedCurrency] = useState(defaultOption || options[0]?.value || '');
//   const [errors, setErrors] = useState([]);

//   useEffect(() => {
//     setInputValue(defaultValue);
//     setSelectedCurrency(defaultOption || options[0]?.value || '');
//   }, [defaultValue, defaultOption, options]);

//   const effectiveValidators = isRequired
//     ? [...validators, (val) => (val ? true : 'This field is required')]
//     : validators;

//   const validateInput = (value) => {
//     const newErrors = effectiveValidators
//       .map((validator) => {
//         const result = validator(value);
//         return result === true ? null : result;
//       })
//       .filter((error) => error);

//     setErrors(newErrors);
//     return newErrors;
//   };

//   const handleInputChange = (event) => {
//     const newValue = event.target.value;
//     setInputValue(newValue);

//     const newErrors = validateInput(newValue);

//     if (onChange) {
//       onChange(name, {
//         price: newValue,
//         currency: selectedCurrency,
//       });
//     }
//   };

//   const handleSelectChange = (event) => {
//     const newCurrency = event.target.value;
//     setSelectedCurrency(newCurrency);

//     if (onChange) {
//       onChange(name, {
//         price: inputValue,
//         currency: newCurrency,
//       });
//     }
//   };

//   const displayErrors = error ? [error] : errors;

//   return (
//     <div className={`small-compo-box-container ${className}`}>
//       <select
//         value={selectedCurrency}
//         onChange={handleSelectChange}
//         className="fts-13 border-none"
//       >
//         {options.map((option, index) => (
//           <option className="fts-13" key={index} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//       <input
//         className={`input-box compo-box-input border-none common-text fts-13 ${
//           errors.length > 0 ? 'input-error' : ''
//         }`}
//         type={type}
//         value={inputValue}
//         onChange={handleInputChange}
//         placeholder=""
//         name={name}
//       />
//       <label className={`lt-gray fixed-input-label ${inputValue ? 'has-value' : ''}`}>
//         {label}
//       </label>
//       {displayErrors.length > 0 && (
//         <div className="input-error-message">
//           {displayErrors[0]}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InputAndSelectCompoBoxSmall;





